module.exports = __webpack_public_path__ + "static/img/image-1.d95ef30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_feature/dashboard/admin/image-1.png
// module id = 41BJ
// module chunks = 1